<script>
import {
  timeList,
  dateList,
  comBit,
  dateBit,
  timeBit,
  zeroList,
  updateList,
  contentTypeList
} from './list'
import { CodeGeneratorServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
const cgsp = new CodeGeneratorServiceProxy()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    applicationObjectCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    item: {
      handler(val) {
        console.log(this.item)
        this.handleReady(val)
        this.getFormFields()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dateList, // 日期类型
      timeList, // 时间类型
      comBit, // 部位符
      dateBit, // 日期分隔符
      timeBit, // 时间分隔符
      zeroList, // 缺位补零
      updateList, // 更新周期
      contentTypeList, //内容列表
      complementBit: [],
      selectType: '',
      confirmLoading: false,
      contentList: []
    }
  },
  computed: {
    showBit() {
      // 展示分隔符
      let show = false
      if (this.item.type == 2 || this.item.type == 3 || this.selectType == '2') {
        show = true
      }
      return show
    },
    showBitName() {
      let name = '补位符'
      if (this.item.type == 1 && this.selectType == '2') {
        name = '补位符'
      } else {
        name = '分隔符'
      }
      return name
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleReady(val) {
      this.selectType = ''
      this.confirmLoading = false
      this.complementBit = []
      this.contentList = []
      if (val.contentType && this.item.type != 4) {
        this.selectType = val.contentType + ''
      }

      if (val.type === 2) {
        this.complementBit = this.dateBit
      } else if (val.type === 3) {
        this.complementBit = this.timeBit
      } else {
        this.complementBit = this.comBit
      }
    },
    changeContentType(val) {
      this.selectType = val
      if (val == '2' || val == '3') {
        if (this.contentList && this.contentList.length) {
          this.form.setFieldsValue({
            content: this.contentList[0].name
          })
        }
      } else {
        this.form.setFieldsValue({
          content: ''
        })
      }
    },
    handleCancel() {
      this.form.resetFields()
      this.$emit('cancel')
    },
    getFormFields() {
      this.contentList = []
      if (this.applicationObjectCode !== '') {
        cgsp.getFormFields(this.applicationObjectCode).then((res) => {
          if (res && res.length) {
            this.contentList = res
            console.log(this.contentList)
          }
        })
      }
    },
    findName() {
      let name = ''
      let field = undefined
      if (this.item.bizDataId !== null) {
        field = this.contentList.find(
          (res) => res.bizDataId == this.item.bizDataId && res.code === this.item.content
        )
      } else {
        field = this.contentList.find((res) => res.code === this.item.content)
      }
      if (field) {
        name = field.name
      }
      return name
    },
    handleSave() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.selectType == '2' || this.selectType == '3') {
            const typeItem = this.contentList.find((res) => res.name === values.content)
            if (typeItem) {
              values.content = typeItem.code
              values.bizDataId = typeItem.bizDataId
            }
          }
          if (this.item.type == '4') {
            if (values.minLength > values.maxLength) {
              this.$message.warning('最小值不能大于最大值')
              return
            }
            if (values.minLength + values.step > values.maxLength) {
              this.$message.warning('最小值加步进不能大于最大值')
              return
            }
          }
          this.confirmLoading = true
          this.contentList = []
          this.$emit('save', values)
          this.form.resetFields()
          setTimeout(() => {
            this.confirmLoading = false
          }, 100)
        }
      })
    }
  }
}
</script>

<template>
  <a-modal
    :title="'新建内容'"
    :visible="visible"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
    @ok="handleSave()"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-form-item v-if="item.type == '1'" label="内容类型">
        <a-select
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'contentType',
            {
              initialValue: item.contentType,
              rules: [{ required: true, message: '请选择内容类型' }]
            }
          ]"
          @change="(value) => changeContentType(value)"
          placeholder="请选择内容类型"
        >
          <a-select-option v-for="(date, index) in contentTypeList" :key="index" :value="date.key">
            {{ date.value }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="item.type == '1'" label="文本内容">
        <a-select
          v-if="selectType == '2' || selectType == '3'"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'content',
            {
              initialValue: findName(),
              rules: [{ required: true, message: '请选择文本内容' }]
            }
          ]"
          placeholder="请选择文本内容"
        >
          <a-select-option v-for="(date, index) in contentList" :key="index" :value="date.name">
            {{ date.name }}
          </a-select-option>
        </a-select>
        <a-input
          v-decorator="[
            'content',
            {
              initialValue: item.content ? item.content : '',
              rules: [{ required: true, message: '请输入文本内容' }]
            }
          ]"
          :maxLength="255"
          v-else
          placeholder="请输入文本内容"
        />
      </a-form-item>
      <a-form-item v-if="item.type == '1' && selectType == '2'" label="长度">
        <a-input-number
          style="width: 100%"
          :min="0"
          :max="999999"
          placeholder="请输入长度"
          v-decorator="[
            'length',
            {
              initialValue: item.length ? item.length : ''
            }
          ]"
        />
      </a-form-item>
      <a-form-item v-if="item.type == '1' && selectType == '2'" label="起始位">
        <a-input-number
          style="width: 100%"
          :min="0"
          :max="999999"
          placeholder="请输入起始位"
          v-decorator="[
            'startBit',
            {
              initialValue: item.startBit ? item.startBit : '',
              rules: [{ required: true, message: '请输入起始位' }]
            }
          ]"
        />
      </a-form-item>

      <a-form-item v-if="item.type == '2'" label="日期格式">
        <a-select
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'dateFormat',
            {
              initialValue: item.dateFormat,
              rules: [{ required: true, message: '请选择日期格式' }]
            }
          ]"
          placeholder="请选择日期格式"
        >
          <a-select-option v-for="(date, index) in dateList" :key="index" :value="date.key">
            {{ date.value }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-if="item.type == '3'" label="时间格式">
        <a-select
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'timeFormat',
            {
              initialValue: item.timeFormat,
              rules: [{ required: true, message: '请选择时间格式' }]
            }
          ]"
          placeholder="请选择时间格式"
        >
          <a-select-option v-for="(date, index) in timeList" :key="index" :value="date.key">
            {{ date.value }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="showBitName" v-if="showBit">
        <a-select
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'complementBit',
            {
              initialValue: item.complementBit,
              rules: [{ required: true, message: `请选择${showBitName}` }]
            }
          ]"
          :placeholder="`请选择${showBitName}`"
        >
          <a-select-option v-for="(date, index) in complementBit" :key="index" :value="date.key">
            {{ date.value }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <template v-if="item.type == '4'">
        <a-form-item label="最小值">
          <a-input-number
            style="width: 100%"
            :min="0"
            :max="999999"
            v-decorator="[
              'minLength',
              {
                initialValue: item.minLength ? item.minLength : '',
                rules: [{ required: true, message: '请输入最小值' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="最大值">
          <a-input-number
            style="width: 100%"
            :min="0"
            :max="9999"
            v-decorator="[
              'maxLength',
              {
                initialValue: item.maxLength,
                rules: [{ required: true, message: '请输入最大值' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="步进">
          <a-input-number
            style="width: 100%"
            :min="0"
            :max="999999"
            v-decorator="[
              'step',
              {
                initialValue: item.step,
                rules: [{ required: true, message: '请输入步进' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="缺位补零">
          <a-select
            show-search
            :filter-option="filterOption"
            v-decorator="[
              'zeroComplement',
              {
                initialValue: item.zeroComplement,
                rules: [{ required: true, message: '请选择缺位补零' }]
              }
            ]"
            placeholder="请选择缺位补零"
          >
            <a-select-option v-for="(date, index) in zeroList" :key="index" :value="date.key">
              {{ date.value }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="更新周期">
          <a-select
            show-search
            :filter-option="filterOption"
            v-decorator="[
              'updateCycle',
              {
                initialValue: item.updateCycle,
                rules: [{ required: true, message: '请选择更新周期' }]
              }
            ]"
            placeholder="请选择更新周期"
          >
            <a-select-option v-for="(date, index) in updateList" :key="index" :value="date.key">
              {{ date.value }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
    </a-form>
  </a-modal>
</template>

<style></style>
